import { render, staticRenderFns } from "./koulutussopimus-card.vue?vue&type=template&id=1d66ec80&"
import script from "./koulutussopimus-card.vue?vue&type=script&lang=ts&"
export * from "./koulutussopimus-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports